<script lang="ts" setup>
import { MobileFiltersBarProps } from "~/components/Filters/Utils/MobileFiltersBar.props"

withDefaults(defineProps<MobileFiltersBarProps>(), {
  nFilters: 0,
  nResults: 0,
  sortingOpen: false,
  showResults: false
})

const emit = defineEmits<{ (e: "onFilter"): void; (e: "onSort"): void }>()
</script>

<template>
  <div class="mobile-filters-bar">
    <div
      class="
        mobile-filters-bar__controls
        border-black-10
        bg-tiffany-10
        flex
        border-y
        py-2
      "
    >
      <button
        class="
          mobile-filters-bar__btn
          beaver-bold
          border-black-10
          gap-x-2
          border-r
        "
        @click="emit('onFilter')"
      >
        <UtilsIcon name="Options.svg" class="h-5 w-5" />
        {{ $t("filters.utils.mobileFiltersBar.filter") }}
        <BadgeCounter v-if="!!nFilters" :counter="nFilters" />
      </button>
      <button
        class="mobile-filters-bar__btn beaver-bold"
        @click="emit('onSort')"
      >
        {{ $t("filters.utils.mobileFiltersBar.sort") }}
        <UtilsIcon
          name="ChevronDown.svg"
          class="h-5 w-5 transition-transform duration-300"
          :class="{ 'rotate-x-180': sortingOpen }"
        />
      </button>
    </div>
    <p v-if="showResults" class="mobile-filters-bar__results mouse px-4 py-2">
      {{ `${nResults} ${$t("filters.utils.mobileFiltersBar.results")}` }}
    </p>
  </div>
</template>

<style lang="scss" scoped>

.mobile-filters-bar {
  &__btn {
    @apply flex flex-1 items-center justify-center px-4 py-1 uppercase;
  }
}

</style>
